<template>
  <div class="receive-modal-box" v-if="visible">
   <div class="receive-modal">
      <div class="receive-content">
        <div class="receive-title">{{title}}</div>
        <div class="receive-name">恭喜</div>
        <div class="receive-type-desc">
          获得<span v-for="(item,i) in dataList" :key="i">{{i?'、':''}}{{item.name}}</span>
        </div>
        <div class="receive-desc">
          优惠券可在“个人中心”-“我的优惠券”中查看
        </div>
        <div class="receive-btn" @click="confirm">
          立即领取
        </div>
      </div>
      <div class="receive-cancel" @click="cancel">&nbsp;</div>
   </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import { Toast } from "vant";
export default {
  name: "receiveModal",
  computed:{
    ...mapState(['user'])
  },
  mounted(){
  },
  data () {
    return {
      visible: false,
      title: '购买成功',
      dataList: [

      ]
    }
  },
  methods: {
    showModal(v) {
      this.dataList=v
      this.visible=!this.visible
    },
    confirm() {
      Toast('领取成功！');
      this.visible=false
    },
    cancel() {
      this.visible=false
      this.$emit("cancelEvent");
    }
  }
}
</script>
<style  lang='scss' scoped>
.receive-modal-box{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,.5);
  z-index: 99999;
  .receive-modal{
    height: 800px;
    width:540px;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: url('~@/assets/images/lihe-lq.png') no-repeat center center;
    background-size:100% 100% ;
    text-align: center;
    .receive-title{
      line-height: 100px;
      color: #fff;
      font-weight: 700;
      font-size: 38px;
      text-shadow: 4px 4px 5px rgba(252,137,72,.9);
    } 
    .receive-name{
      font-size: 52px;
      font-weight: 700;
      line-height: 60px;
      color: #ba602c;
    } 
    .receive-type-desc{
      font-size: 32px;
      color: #b8612b;
      height: 100px;
      overflow:hidden; //超出的文本隐藏
      text-overflow:ellipsis; //用省略号显示
      white-space:nowrap; //不换行
      line-height: 100px;
      max-width: 96%;
      margin: 0 auto;
    }
    .receive-desc{
      padding: 0 12%;
      color: #664826;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      height: 70px;
      padding-top: 24vh;
    }
    .receive-btn{
      text-align: center;
      line-height: 90px;
      font-size: 32px;
      font-weight: 700;
      color: #985e0c;
    }
    .receive-cancel{
      position: absolute;
      left: calc(50% - 40px);
      top: -120px;
      background: url('~@/assets/images/guanbi.png') no-repeat center center;
      background-size:99% 99%;
      width: 80px;
      height: 80px;
    }
  }
}
</style>